// QQCARD catalog — MyCard 點數卡專屬
// 簡化為單一品牌 (MyCard) × 7 個面額 + 支援遊戲列表

export const CATEGORIES = [
  { id: 'all', name: { 'zh-TW': '全部面額', 'zh-CN': '全部面额', en: 'All', ja: 'すべて', ko: '전체' } },
  { id: 'small', name: { 'zh-TW': '小額入門', 'zh-CN': '小额入门', en: 'Starter', ja: 'スターター', ko: '입문' } },
  { id: 'medium', name: { 'zh-TW': '中階熱銷', 'zh-CN': '中阶热销', en: 'Popular', ja: '人気', ko: '인기' } },
  { id: 'large', name: { 'zh-TW': '大額儲值', 'zh-CN': '大额储值', en: 'Premium', ja: 'プレミアム', ko: '프리미엄' } },
];

export const REGIONS = [
  { code: 'TW', name: '台灣', flag: '🇹🇼' },
  { code: 'HK', name: '香港', flag: '🇭🇰' },
];

export const CURRENCIES = {
  TWD: { symbol: 'NT$', rate: 1, name: 'TWD' },
  USD: { symbol: '$', rate: 0.031, name: 'USD' },
  HKD: { symbol: 'HK$', rate: 0.24, name: 'HKD' },
  CNY: { symbol: '¥', rate: 0.22, name: 'CNY' },
  JPY: { symbol: '¥', rate: 4.7, name: 'JPY' },
};

export const PAYMENT_METHODS = [
  { id: 'carrier', name: '電信小額', desc: '中華 · 台哥大 · 遠傳' },
  { id: 'credit', name: '信用卡', desc: 'Visa · Mastercard · JCB' },
  { id: 'linepay', name: 'LINE Pay', desc: '一鍵掃碼支付' },
  { id: 'applepay', name: 'Apple Pay', desc: 'Touch ID · Face ID' },
  { id: 'googlepay', name: 'Google Pay', desc: '安全快速' },
  { id: 'jkopay', name: '街口支付', desc: '台灣超商通用' },
  { id: 'sevenpay', name: '超商代碼', desc: '7-11 · 全家 · 萊爾富' },
  { id: 'unionpay', name: '銀聯卡', desc: '全球受理' },
];

// MyCard 品牌色
const MC_BG = '#FF6B00';
const MC_FG = '#ffffff';
// MC_IMG unused — each product specifies its own image path now

// 7 個 MyCard 面額作為獨立商品卡（OneOne 風格）
export const PRODUCTS = [
  {
    id: 'mycard-50',
    slug: 'mycard-50',
    name: 'MyCard 50 點',
    en: 'MyCard 50 Points',
    publisher: '智冠科技',
    category: 'small',
    bg: MC_BG,
    fg: MC_FG,
    logoText: '50',
    image: '/images/mycard/mc-50.jpg',
    tagline: '新手入門首選',
    region: 'TW',
    desc: 'MyCard 50 點，適合單次小額遊戲道具購買、儲值試水。支援 300+ 款熱門遊戲。完成付款後即時收到序號。',
    denominations: [{ points: 50, price: 59, label: '50 點' }],
  },
  {
    id: 'mycard-150',
    slug: 'mycard-150',
    name: 'MyCard 150 點',
    en: 'MyCard 150 Points',
    publisher: '智冠科技',
    category: 'small',
    bg: MC_BG,
    fg: MC_FG,
    logoText: '150',
    image: '/images/mycard/mc-150.jpg',
    tagline: '輕量月卡剛剛好',
    region: 'TW',
    desc: 'MyCard 150 點，適合一般月卡或單次活動禮包，支援眾多手遊與線上遊戲。',
    denominations: [{ points: 150, price: 177, label: '150 點' }],
  },
  {
    id: 'mycard-300',
    slug: 'mycard-300',
    name: 'MyCard 300 點',
    en: 'MyCard 300 Points',
    publisher: '智冠科技',
    category: 'medium',
    bg: MC_BG,
    fg: MC_FG,
    logoText: '300',
    image: '/images/mycard/mc-300.jpg',
    tagline: '玩家熱銷面額',
    region: 'TW',
    hot: true,
    desc: 'MyCard 300 點，玩家最常購買的面額之一，適合月卡 + 活動禮包搭配。',
    denominations: [{ points: 300, price: 345, label: '300 點' }],
  },
  {
    id: 'mycard-500',
    slug: 'mycard-500',
    name: 'MyCard 500 點',
    en: 'MyCard 500 Points',
    publisher: '智冠科技',
    category: 'medium',
    bg: MC_BG,
    fg: MC_FG,
    logoText: '500',
    image: '/images/mycard/mc-500.jpg',
    tagline: '中階儲值',
    region: 'TW',
    desc: 'MyCard 500 點，適合儲值禮包、季卡與道具組合包購買。',
    denominations: [{ points: 500, price: 575, label: '500 點' }],
  },
  {
    id: 'mycard-1000',
    slug: 'mycard-1000',
    name: 'MyCard 1000 點',
    en: 'MyCard 1000 Points',
    publisher: '智冠科技',
    category: 'large',
    bg: MC_BG,
    fg: MC_FG,
    logoText: '1K',
    image: '/images/mycard/mc-1000.jpg',
    tagline: '大額儲值省 5%',
    region: 'TW',
    hot: true,
    desc: 'MyCard 1000 點大額儲值，適合資深玩家月度儲值或活動限定大禮包購買。',
    denominations: [{ points: 1000, price: 1169, label: '1000 點' }],
    discount: 5,
  },
  {
    id: 'mycard-3000',
    slug: 'mycard-3000',
    name: 'MyCard 3000 點',
    en: 'MyCard 3000 Points',
    publisher: '智冠科技',
    category: 'large',
    bg: MC_BG,
    fg: MC_FG,
    logoText: '3K',
    image: '/images/mycard/mc-3000.jpg',
    tagline: 'VIP 玩家專屬',
    region: 'TW',
    desc: 'MyCard 3000 點，適合高消費玩家月度儲值，搭配 QQCARD 會員回饋更划算。',
    denominations: [{ points: 3000, price: 3499, label: '3000 點' }],
  },
  {
    id: 'mycard-5000',
    slug: 'mycard-5000',
    name: 'MyCard 5000 點',
    en: 'MyCard 5000 Points',
    publisher: '智冠科技',
    category: 'large',
    bg: MC_BG,
    fg: MC_FG,
    logoText: '5K',
    image: '/images/mycard/mc-5000.jpg',
    tagline: '最大面額 · VIP 升等',
    region: 'TW',
    new: true,
    desc: 'MyCard 5000 點最高面額儲值卡。單次購買即達 VIP Silver 等級門檻。',
    denominations: [{ points: 5000, price: 5799, label: '5000 點' }],
  },
];

// MyCard 支援的熱門遊戲（台灣常見）
export const SUPPORTED_GAMES = [
  {
    id: 'maplestory',
    name: '新楓之谷',
    publisher: 'Nexon',
    bg: '#FF8C00',
    image: 'https://images.unsplash.com/photo-1614680376573-df3480f0c6ff?w=800&q=80&auto=format&fit=crop',
    tags: ['MMORPG', 'PC'],
  },
  {
    id: 'lineageW',
    name: '天堂 W',
    publisher: 'NCSOFT',
    bg: '#8B0000',
    image: 'https://images.unsplash.com/photo-1502134249126-9f3755a50d78?w=800&q=80&auto=format&fit=crop',
    tags: ['MMORPG', '手機'],
  },
  {
    id: 'eternal',
    name: '永恆紀元',
    publisher: 'IGG',
    bg: '#4B0082',
    image: 'https://images.unsplash.com/photo-1542903660-eedba2cda473?w=800&q=80&auto=format&fit=crop',
    tags: ['MMORPG', '手機'],
  },
  {
    id: 'dragonnest',
    name: '龍之谷 M',
    publisher: 'Eyedentity',
    bg: '#DC143C',
    image: 'https://images.unsplash.com/photo-1547036967-23d11aacaee0?w=800&q=80&auto=format&fit=crop',
    tags: ['動作', '手機'],
  },
  {
    id: 'ragnarok',
    name: 'RO 仙境傳說',
    publisher: 'Gravity',
    bg: '#FF1493',
    image: 'https://images.unsplash.com/photo-1518091043644-c1d4457512c6?w=800&q=80&auto=format&fit=crop',
    tags: ['MMORPG', '經典'],
  },
  {
    id: 'tos',
    name: '神魔之塔',
    publisher: 'Madhead',
    bg: '#1C0033',
    image: 'https://images.unsplash.com/photo-1614680376573-df3480f0c6ff?w=800&q=80&auto=format&fit=crop',
    tags: ['手機', '轉珠'],
  },
  {
    id: 'sanguozhi',
    name: '三國志真戰',
    publisher: 'Koei Tecmo',
    bg: '#8B4513',
    image: 'https://images.unsplash.com/photo-1592155931584-901ac15763e3?w=800&q=80&auto=format&fit=crop',
    tags: ['策略', '手機'],
  },
  {
    id: 'fgo',
    name: '命運：冠位指定',
    publisher: 'Aniplex',
    bg: '#191970',
    image: 'https://images.unsplash.com/photo-1614680376573-df3480f0c6ff?w=800&q=80&auto=format&fit=crop',
    tags: ['手機', 'RPG'],
  },
  {
    id: 'blackdesert',
    name: '黑色沙漠',
    publisher: 'Pearl Abyss',
    bg: '#000000',
    image: 'https://images.unsplash.com/photo-1633545495735-25df17fb9f31?w=800&q=80&auto=format&fit=crop',
    tags: ['PC', 'MMORPG'],
  },
  {
    id: 'kartrider',
    name: '跑跑卡丁車 RUSH+',
    publisher: 'Nexon',
    bg: '#FFD700',
    image: 'https://images.unsplash.com/photo-1605870445919-838d190e8e1b?w=800&q=80&auto=format&fit=crop',
    tags: ['競速', '手機'],
  },
  {
    id: 'epic7',
    name: '第七史詩',
    publisher: 'Smilegate',
    bg: '#9370DB',
    image: 'https://images.unsplash.com/photo-1487537708572-3c850b5e856e?w=800&q=80&auto=format&fit=crop',
    tags: ['手機', 'RPG'],
  },
  {
    id: 'diablo-immortal',
    name: '暗黑破壞神：永生不朽',
    publisher: 'Blizzard',
    bg: '#8B0000',
    image: 'https://images.unsplash.com/photo-1502134249126-9f3755a50d78?w=800&q=80&auto=format&fit=crop',
    tags: ['動作', '手機'],
  },
];

// Logo helper
const SI = (slug) => `https://cdn.simpleicons.org/${slug}`;

// 4 個 MyCard 主題 banner（多語）
export const BANNERS = [
  {
    id: 'b1',
    image: '/images/mycard/hero.jpg',
    productId: 'mycard-300',
    i18n: {
      'zh-TW': { eyebrow: 'MyCard 點數卡', title: 'MyCard 300 點 熱銷 NT$345', sub: '玩家最常購買 · 支援 300+ 款遊戲 · 10 秒到帳', cta: '立即購買' },
      'zh-CN': { eyebrow: 'MyCard 点数卡', title: 'MyCard 300 点 热销 NT$345', sub: '玩家最常购买 · 支援 300+ 款游戏 · 10 秒到账', cta: '立即购买' },
      en: { eyebrow: 'MyCard Points', title: 'MyCard 300 Points · NT$345', sub: 'Bestseller · 300+ supported games · 10s delivery', cta: 'Buy now' },
      ja: { eyebrow: 'MyCard ポイント', title: 'MyCard 300ポイント NT$345', sub: '人気No.1 · 300以上のゲーム対応 · 10秒配信', cta: '購入する' },
      ko: { eyebrow: 'MyCard 포인트', title: 'MyCard 300P · NT$345', sub: '베스트셀러 · 300+ 게임 지원 · 10초 배송', cta: '구매하기' },
    },
  },
  {
    id: 'b2',
    image: '/images/mycard/mc-1000.jpg',
    productId: 'mycard-1000',
    i18n: {
      'zh-TW': { eyebrow: '大額儲值', title: 'MyCard 1000 點 省 5%', sub: 'NT$1,169 直接抵 1000 點 · 大額玩家專屬優惠', cta: '查看商品' },
      'zh-CN': { eyebrow: '大额储值', title: 'MyCard 1000 点 省 5%', sub: 'NT$1,169 直接抵 1000 点 · 大额玩家专属优惠', cta: '查看商品' },
      en: { eyebrow: 'Premium', title: 'MyCard 1000 Points · Save 5%', sub: 'NT$1,169 for 1,000 pts · For heavy gamers', cta: 'View product' },
      ja: { eyebrow: '大容量', title: 'MyCard 1000ポイント 5%OFF', sub: 'NT$1,169 = 1,000ポイント · 大量プレイヤー専用', cta: '商品を見る' },
      ko: { eyebrow: '프리미엄', title: 'MyCard 1000P · 5% 할인', sub: 'NT$1,169 = 1,000P · 헤비 게이머 전용', cta: '상품 보기' },
    },
  },
  {
    id: 'b3',
    image: 'https://images.unsplash.com/photo-1547036967-23d11aacaee0?w=1600&q=85&auto=format&fit=crop',
    i18n: {
      'zh-TW': { eyebrow: '支援遊戲', title: '300+ 款熱門遊戲', sub: '新楓之谷 · 天堂 W · 永恆紀元 · 龍之谷 M · RO 仙境傳說', cta: '查看清單' },
      'zh-CN': { eyebrow: '支持游戏', title: '300+ 款热门游戏', sub: '新枫之谷 · 天堂 W · 永恒纪元 · 龙之谷 M · RO 仙境传说', cta: '查看清单' },
      en: { eyebrow: 'Supported Games', title: '300+ Supported Games', sub: 'MapleStory · Lineage W · Eternal · Dragon Nest M · Ragnarok', cta: 'View list' },
      ja: { eyebrow: '対応ゲーム', title: '300以上のゲーム対応', sub: 'メイプルストーリー · Lineage W · Eternal · Dragon Nest M · ラグナロク', cta: 'リストを見る' },
      ko: { eyebrow: '지원 게임', title: '300개 이상 지원', sub: '메이플 · 리니지 W · Eternal · 드래곤네스트 M · 라그나로크', cta: '목록 보기' },
    },
  },
  {
    id: 'b4',
    image: 'https://images.unsplash.com/photo-1502134249126-9f3755a50d78?w=1600&q=85&auto=format&fit=crop',
    i18n: {
      'zh-TW': { eyebrow: '會員制', title: 'VIP 黑卡 · 階梯式回饋', sub: '消費越多 · 回饋越高 · 最高 8% 終身回饋', cta: '了解會員' },
      'zh-CN': { eyebrow: '会员制', title: 'VIP 黑卡 · 阶梯式回馈', sub: '消费越多 · 回馈越高 · 最高 8% 终身回馈', cta: '了解会员' },
      en: { eyebrow: 'Membership', title: 'VIP Black · Tiered Rebate', sub: 'Spend more, earn more · Up to 8% lifetime rebate', cta: 'Learn more' },
      ja: { eyebrow: 'メンバーシップ', title: 'VIPブラック · 階段式還元', sub: '利用が多いほど還元アップ · 最大8%生涯還元', cta: '詳細を見る' },
      ko: { eyebrow: '멤버십', title: 'VIP 블랙 · 단계별 적립', sub: '소비가 많을수록 적립 증가 · 최대 8% 평생 적립', cta: '자세히 보기' },
    },
  },
];

export const PROMO_TICKER = [
  'MyCard 點數 24 小時自動發卡',
  '完成付款後 10 秒寄送至 Email',
  '支援三大電信小額 · 信用卡 · LINE Pay',
  '300+ 款熱門遊戲均可使用',
  'VIP 會員享 1%~8% 終身回饋',
  '客服 LINE 官方帳號 @qqcard',
];

// MyCard 可儲值遊戲之發行商（皆為已驗證可用的 simpleicons SVG）
export const PARTNER_LOGOS = [
  { name: 'Nexon', logo: SI('nexon') },
  { name: 'Square Enix', logo: SI('squareenix') },
  { name: 'Konami', logo: SI('konami') },
  { name: 'Riot Games', logo: SI('riotgames') },
  { name: 'Epic Games', logo: SI('epicgames') },
  { name: 'Blizzard', logo: SI('battledotnet') },
  { name: 'HoYoverse', logo: SI('mihoyo') },
  { name: 'Ubisoft', logo: SI('ubisoft') },
  { name: 'SEGA', logo: SI('sega') },
  { name: 'EA', logo: SI('ea') },
];

export const TRUST_STATS = [];
export const TESTIMONIALS = [];

export const FEATURES = [
  {
    icon: 'bolt',
    title: { 'zh-TW': '10 秒自動發卡', 'zh-CN': '10 秒自动发卡', en: '10-second delivery', ja: '10秒配信', ko: '10초 배송' },
    desc: { 'zh-TW': '24 小時全自動系統，付款完成即時透過 Email 寄送序號。', 'zh-CN': '24 小时全自动系统，付款完成即时透过 Email 寄送序号。', en: '24/7 automated. Codes sent the moment payment clears.', ja: '24時間自動システム。決済後即時メール送信。', ko: '24/7 자동. 결제 후 즉시 이메일 전송.' },
  },
  {
    icon: 'shield',
    title: { 'zh-TW': '智冠科技授權', 'zh-CN': '智冠科技授权', en: 'Official MyCard', ja: '公式MyCard', ko: '공식 MyCard' },
    desc: { 'zh-TW': '所有 MyCard 序號皆為智冠科技原廠官方卡，安全可靠。', 'zh-CN': '所有 MyCard 序号皆为智冠科技原厂官方卡，安全可靠。', en: 'All codes are 100% official MyCard from Smilegate.', ja: 'すべて公式MyCardコード、100%安全。', ko: '모든 코드는 공식 MyCard, 100% 안전.' },
  },
  {
    icon: 'crypto',
    title: { 'zh-TW': '電信小額付款', 'zh-CN': '电信小额付款', en: 'Carrier Billing', ja: 'キャリア決済', ko: '통신사 결제' },
    desc: { 'zh-TW': '中華電信、台灣大哥大、遠傳電信均可使用電信小額支付。', 'zh-CN': '中华电信、台湾大哥大、远传电信均可使用电信小额支付。', en: 'Chunghwa, Taiwan Mobile, FET — carrier billing supported.', ja: '中華電信、台湾大哥大、遠傳電信のキャリア決済対応。', ko: '중화전신, 대만 모바일, 원전 통신사 결제 지원.' },
  },
  {
    icon: 'support',
    title: { 'zh-TW': '24/7 客服協助', 'zh-CN': '24/7 客服协助', en: '24/7 Support', ja: '24時間サポート', ko: '24/7 지원' },
    desc: { 'zh-TW': 'LINE 官方帳號 @qqcard 即時回覆，平均回覆時間 < 1 分鐘。', 'zh-CN': 'LINE 官方账号 @qqcard 即时回复，平均回复时间 < 1 分钟。', en: 'LINE @qqcard live chat. Avg response under 1 minute.', ja: 'LINE @qqcard 即時対応。平均1分以内。', ko: 'LINE @qqcard 즉시 응답. 평균 1분 이내.' },
  },
  {
    icon: 'gem',
    title: { 'zh-TW': '300+ 款遊戲', 'zh-CN': '300+ 款游戏', en: '300+ Games', ja: '300以上のゲーム', ko: '300+ 게임' },
    desc: { 'zh-TW': '新楓之谷、天堂 W、龍之谷 M、RO 仙境傳說等 300+ 款熱門遊戲。', 'zh-CN': '新枫之谷、天堂 W、龙之谷 M、RO 仙境传说等 300+ 款热门游戏。', en: 'MapleStory, Lineage W, Dragon Nest M, Ragnarok & 300+ more.', ja: 'メイプル、Lineage W、Dragon Nest M、ラグナロクなど300+対応。', ko: '메이플, 리니지W, 드래곤네스트M, 라그나로크 등 300+.' },
  },
  {
    icon: 'discount',
    title: { 'zh-TW': 'VIP 終身回饋', 'zh-CN': 'VIP 终身回馈', en: 'VIP Lifetime Rebate', ja: 'VIP生涯還元', ko: 'VIP 평생 적립' },
    desc: { 'zh-TW': '5 階會員制度，每筆訂單自動回饋 1%~8% 至帳戶。', 'zh-CN': '5 阶会员制度，每笔订单自动回馈 1%~8% 至帐户。', en: '5-tier membership. 1%-8% rebate on every order.', ja: '5階級メンバーシップ。注文ごとに1%-8%還元。', ko: '5단계 멤버십. 주문마다 1%-8% 적립.' },
  },
];

const PERKS = {
  csStd: { 'zh-TW': '基礎客服', 'zh-CN': '基础客服', en: 'Standard support', ja: '標準サポート', ko: '기본 지원' },
  csPriority: { 'zh-TW': '優先客服回覆', 'zh-CN': '优先客服回复', en: 'Priority support', ja: '優先サポート', ko: '우선 지원' },
  csDedicated: { 'zh-TW': '專屬客服窗口', 'zh-CN': '专属客服窗口', en: 'Dedicated support', ja: '専属窓口', ko: '전담 창구' },
  cs11: { 'zh-TW': '一對一專員', 'zh-CN': '一对一专员', en: '1-on-1 specialist', ja: '専任スタッフ', ko: '1:1 전담' },
  csMgr: { 'zh-TW': 'VIP 經理', 'zh-CN': 'VIP 经理', en: 'VIP manager', ja: 'VIPマネージャー', ko: 'VIP 매니저' },
  bday5: { 'zh-TW': '生日 5% 折扣碼', 'zh-CN': '生日 5% 折扣码', en: 'Birthday 5% off', ja: '誕生日5%OFF', ko: '생일 5% 할인' },
  bday10: { 'zh-TW': '生日 10% 折扣碼', 'zh-CN': '生日 10% 折扣码', en: 'Birthday 10% off', ja: '誕生日10%OFF', ko: '생일 10% 할인' },
  bday15: { 'zh-TW': '生日 15% 折扣碼', 'zh-CN': '生日 15% 折扣码', en: 'Birthday 15% off', ja: '誕生日15%OFF', ko: '생일 15% 할인' },
  bday25: { 'zh-TW': '生日 25% 折扣碼', 'zh-CN': '生日 25% 折扣码', en: 'Birthday 25% off', ja: '誕生日25%OFF', ko: '생일 25% 할인' },
  bday30: { 'zh-TW': '30% 折扣碼', 'zh-CN': '30% 折扣码', en: '30% off code', ja: '30%OFFコード', ko: '30% 할인' },
  newsletter: { 'zh-TW': '訂閱電子報', 'zh-CN': '订阅电子报', en: 'Newsletter', ja: 'ニュースレター', ko: '뉴스레터' },
  monthlyCode: { 'zh-TW': '月度限量優惠碼', 'zh-CN': '月度限量优惠码', en: 'Monthly exclusive codes', ja: '月次限定コード', ko: '월간 한정 코드' },
  doubleRebate: { 'zh-TW': '雙倍回饋活動', 'zh-CN': '双倍回馈活动', en: 'Double-rebate events', ja: '二倍還元', ko: '2배 적립' },
  newAlert: { 'zh-TW': '新品搶先通知', 'zh-CN': '新品抢先通知', en: 'Early new alerts', ja: '新商品先行通知', ko: '신상품 알림' },
  vipExclusive: { 'zh-TW': 'VIP 專屬優惠', 'zh-CN': 'VIP 专属优惠', en: 'VIP-only offers', ja: 'VIP限定', ko: 'VIP 전용' },
  refundMax: { 'zh-TW': '退款協商最高權限', 'zh-CN': '退款协商最高权限', en: 'Top refund priority', ja: '返金交渉最優先', ko: '환불 최우선' },
};
const perk = (key, lang) => (PERKS[key] && (PERKS[key][lang] || PERKS[key]['zh-TW'])) || key;

export const getVipTiers = (lang) => [
  { id: 'bronze', name: 'Bronze', color: '#cd7f32', threshold: 0, rebate: '1%',
    perks: ['csStd', 'bday5', 'newsletter'].map((k) => perk(k, lang)) },
  { id: 'silver', name: 'Silver', color: '#c0c0c0', threshold: 3000, rebate: '2%',
    perks: ['csPriority', 'bday10', 'monthlyCode'].map((k) => perk(k, lang)) },
  { id: 'gold', name: 'Gold', color: '#ffd700', threshold: 10000, rebate: '3%',
    perks: ['csDedicated', 'bday15', 'doubleRebate'].map((k) => perk(k, lang)) },
  { id: 'platinum', name: 'Platinum', color: '#e5e4e2', threshold: 30000, rebate: '5%',
    perks: ['cs11', 'bday25', 'newAlert', 'vipExclusive'].map((k) => perk(k, lang)) },
  { id: 'black', name: 'BLACK', color: '#000000', threshold: 100000, rebate: '8%',
    perks: ['csMgr', 'bday30', 'vipExclusive', 'refundMax'].map((k) => perk(k, lang)) },
];

export const VIP_TIERS = getVipTiers('zh-TW');

export const FAQ = [
  {
    q: 'MyCard 點數可以用在哪些遊戲？',
    a: '新楓之谷、天堂 W、永恆紀元、龍之谷 M、RO 仙境傳說、神魔之塔、三國志真戰、命運：冠位指定、黑色沙漠、跑跑卡丁車 RUSH+ 等 300+ 款熱門遊戲均可使用。',
  },
  {
    q: '購買後多久能收到 MyCard 序號？',
    a: '完成付款後 10 秒內自動寄送至您的 Email 信箱，並同步顯示於訂單頁面。任何時候皆可至會員中心 → 訂單再次查看。',
  },
  {
    q: '可以用電信小額付款嗎？',
    a: '可以。我們支援中華電信、台灣大哥大、遠傳電信三大電信業者的小額付款服務。其他支援方式包含信用卡 (Visa/Mastercard/JCB)、LINE Pay、Apple Pay、Google Pay、街口、超商代碼。',
  },
  {
    q: '收到序號後要如何儲值至遊戲？',
    a: '1) 開啟遊戲商提供的儲值頁面 2) 選擇 MyCard 點數卡 3) 輸入 16 碼序號 4) 確認儲值。如遇任何問題請使用右下角即時客服協助。',
  },
  {
    q: '可以退款嗎？',
    a: '未使用之未開卡序號 7 天內可申請全額退款。已輸入遊戲帳號之序號依消費者保護法不適用 7 日鑑賞期，但若為系統異常我們將協助補發或退款。',
  },
  {
    q: 'VIP 會員有什麼好處？',
    a: '5 階會員制度（Bronze → Silver → Gold → Platinum → BLACK），每筆 MyCard 訂單自動回饋 1%~8% 至帳戶。生日當月並可享 5%~30% 折扣碼。',
  },
  {
    q: '為什麼這裡比官方價便宜？',
    a: 'QQCARD 為 MyCard 官方授權合作通路，透過大宗採購與電商最佳化降低營運成本，將節省部分回饋給玩家。所有序號 100% 為原廠官方卡。',
  },
  {
    q: '能買大量 MyCard 點數嗎？',
    a: '可以。電競戰隊、實況主、企業福委會等大宗採購可享 0.5%~3% 額外折讓。請寄信至 hshamg690111@hotmail.com 洽詢。',
  },
];

export const BLOG_POSTS = [
  {
    id: 1,
    title: 'MyCard 點數 2026 最划算購買時機與優惠整理',
    excerpt: '每月、每季 MyCard 都有不同優惠週期，這篇整理出最容易拿到 5% 折扣的儲值時機。',
    cover: 'https://images.unsplash.com/photo-1571171637578-41bc2dd41cd2?w=900&q=85&auto=format&fit=crop',
    tag: '攻略',
    date: '2026-05-08',
    read: '6 min',
    author: 'QQCARD 編輯部',
  },
  {
    id: 2,
    title: '新楓之谷玩家必看：MyCard 儲值流程一次搞懂',
    excerpt: '從購買 MyCard 到 NX 點數轉換的完整教學，含常見錯誤與解決方法。',
    cover: 'https://images.unsplash.com/photo-1614680376573-df3480f0c6ff?w=900&q=85&auto=format&fit=crop',
    tag: '教學',
    date: '2026-05-01',
    read: '8 min',
    author: 'QQCARD 編輯部',
  },
  {
    id: 3,
    title: '天堂 W 月卡 + MyCard 大額方案哪個划算？',
    excerpt: '天堂 W 主流氪金方式分析，配合 QQCARD 的 5% 折扣，月度開銷可降多少。',
    cover: 'https://images.unsplash.com/photo-1502134249126-9f3755a50d78?w=900&q=85&auto=format&fit=crop',
    tag: '精選',
    date: '2026-04-22',
    read: '10 min',
    author: 'QQCARD 編輯部',
  },
  {
    id: 4,
    title: 'MyCard 電信小額付款設定完整教學',
    excerpt: '中華電信、台灣大哥大、遠傳的小額付款開通方式與每月額度限制詳解。',
    cover: 'https://images.unsplash.com/photo-1601933973783-43cf8a7d4c5f?w=900&q=85&auto=format&fit=crop',
    tag: '教學',
    date: '2026-04-12',
    read: '5 min',
    author: 'QQCARD 編輯部',
  },
];

export const FOOTER_LINKS = {
  about: {
    title: '關於 QQCARD',
    links: [
      { label: '品牌故事', target: { type: 'info', id: 'about' } },
      { label: '商業合作', target: { type: 'info', id: 'b2b' } },
      { label: '加入我們', target: { type: 'info', id: 'careers' } },
    ],
  },
  service: {
    title: '客戶服務',
    links: [
      { label: '儲值教學', target: { type: 'info', id: 'guide' } },
      { label: '訂單查詢', target: { type: 'account' } },
      { label: '退款政策', target: { type: 'info', id: 'refund' } },
      { label: '防詐騙宣導', target: { type: 'info', id: 'fraud' } },
      { label: '24/7 客服', target: { type: 'chat' } },
    ],
  },
  products: {
    title: 'MyCard 點數',
    links: [
      { label: 'MyCard 50 點', target: { type: 'product', id: 'mycard-50' } },
      { label: 'MyCard 150 點', target: { type: 'product', id: 'mycard-150' } },
      { label: 'MyCard 300 點', target: { type: 'product', id: 'mycard-300' } },
      { label: 'MyCard 1000 點', target: { type: 'product', id: 'mycard-1000' } },
      { label: 'MyCard 3000 點', target: { type: 'product', id: 'mycard-3000' } },
      { label: 'MyCard 5000 點', target: { type: 'product', id: 'mycard-5000' } },
    ],
  },
  legal: {
    title: '法律條款',
    links: [
      { label: '服務條款', target: { type: 'info', id: 'terms' } },
      { label: '隱私權政策', target: { type: 'info', id: 'privacy' } },
      { label: 'Cookie 政策', target: { type: 'info', id: 'cookie' } },
      { label: '智慧財產', target: { type: 'info', id: 'ip' } },
      { label: '責任聲明', target: { type: 'info', id: 'disclaimer' } },
    ],
  },
};

export const SOCIAL_LINKS = [
  { name: 'Facebook', icon: 'facebook', href: 'https://www.facebook.com/' },
  { name: 'LINE', icon: 'line', href: 'https://line.me/' },
  { name: 'Instagram', icon: 'instagram', href: 'https://www.instagram.com/' },
  { name: 'YouTube', icon: 'youtube', href: 'https://www.youtube.com/' },
];

export const PAYMENT_LOGOS = [
  { name: 'Visa', logo: 'https://cdn.simpleicons.org/visa/1A1F71' },
  { name: 'Mastercard', logo: 'https://cdn.simpleicons.org/mastercard/EB001B' },
  { name: 'JCB', logo: 'https://cdn.simpleicons.org/jcb/0E4C96' },
  { name: 'American Express', logo: 'https://cdn.simpleicons.org/americanexpress/2E77BB' },
  { name: 'Apple Pay', logo: 'https://cdn.simpleicons.org/applepay/000000' },
  { name: 'Google Pay', logo: 'https://cdn.simpleicons.org/googlepay/4285F4' },
  { name: 'LINE Pay', logo: 'https://cdn.simpleicons.org/line/06C755' },
];
